import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import siteConfig from "../siteConfig";
import { isClientReloadRequired, subscribeClientReload, clientReloadReason } from "../utils/clientReload";

export function ClientReloadGate({ onReload = () => window.location.reload(), availableVersion, changelog, requiresLogout = false }) {
  const [required, setRequired] = useState(isClientReloadRequired);
  const [reason, setReason] = useState(clientReloadReason);
  useEffect(() => {
    const unsubscribe = subscribeClientReload(() => { setRequired(true); setReason(clientReloadReason()); });
    if (isClientReloadRequired()) setRequired(true);
    return unsubscribe;
  }, []);
  return <Modal open={required} centered closable={false} maskClosable={false} keyboard={false} zIndex={100000}
    title={reason === 'shared-only' ? 'Chat settings changed. Reload to continue.' : "New version — please reload"}
    footer={<Button type="primary" onClick={onReload}>Reload Uzdpart360</Button>}>
    <p>This tab must reload before you continue. Your unsent text drafts are saved on this device.</p>
    <p>Current version: v{siteConfig.version} · build {siteConfig.build_no}</p>
    {availableVersion?.version && <p>Available: v{availableVersion.version} · build {availableVersion.build_no}</p>}
    {changelog && <div style={{ maxHeight: "35vh", overflowY: "auto", whiteSpace: "pre-wrap", marginBottom: 12 }}>{changelog}</div>}
    {requiresLogout && <p>This update requires signing in again after reloading.</p>}
  </Modal>;
}
